export default __webpack_public_path__ + "static/media/icon-calendar.4f1b8606.svg";